import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent {
  @Input() feature: any;
  @Input() maxImageSize: number;
  @Output() featureChange = new EventEmitter<any>();

  constructor(private messageService: MessageService) {}

  onFileDropped(event: any) {
    this.prepareFilesList(event);
  }

  fileBrowseHandler(event: any) {
    this.prepareFilesList(event.target.files);
  }

  prepareFilesList(files: Array<any>) {
    for (const file of files) {
      if (this.isValidFile(file)) {
        if (!this.feature.value) this.feature.value = [];
        this.feature.value.push({
          name: file.name,
          url: URL.createObjectURL(file),
          size: file.size,
          type: 'image',
          file: file,
          isUploaded: false
        });
      }
    }
    this.featureChange.emit(this.feature);
  }

  deleteFile(index: number) {
    this.feature.value.splice(index, 1);
    this.featureChange.emit(this.feature);
  }

  isValidFile(file: any): boolean {
    if (file.type.startsWith('image/')) {
      if (file.size <= this.maxImageSize) {
        return true;
      } else {
        this.messageService.add({severity: 'error', summary: 'Error', detail: 'File size exceeded'});
      }
    } else {
      this.messageService.add({severity: 'error', summary: 'Error', detail: 'Invalid file type'});
    }
    return false;
  }
}